module.exports = __webpack_public_path__ + "img/icon_d.74179e2e.png";